var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrosshairs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 7.25H14.6875C14.3438 4.125 11.875 1.65625 8.75 1.3125V0.375C8.75 0.1875 8.5625 0 8.375 0H7.625C7.40625 0 7.25 0.1875 7.25 0.375V1.3125C4.09375 1.65625 1.625 4.125 1.28125 7.25H0.375C0.15625 7.25 0 7.4375 0 7.625V8.375C0 8.59375 0.15625 8.75 0.375 8.75H1.28125C1.625 11.9062 4.09375 14.375 7.25 14.7188V15.625C7.25 15.8438 7.40625 16 7.625 16H8.375C8.5625 16 8.75 15.8438 8.75 15.625V14.7188C11.875 14.375 14.3438 11.9062 14.6875 8.75H15.625C15.8125 8.75 16 8.59375 16 8.375V7.625C16 7.4375 15.8125 7.25 15.625 7.25ZM8.75 13.2188V11.875C8.75 11.6875 8.5625 11.5 8.375 11.5H7.625C7.40625 11.5 7.25 11.6875 7.25 11.875V13.2188C4.9375 12.875 3.125 11.0625 2.78125 8.75H4.125C4.3125 8.75 4.5 8.59375 4.5 8.375V7.625C4.5 7.4375 4.3125 7.25 4.125 7.25H2.78125C3.125 4.96875 4.9375 3.15625 7.25 2.8125V4.125C7.25 4.34375 7.40625 4.5 7.625 4.5H8.375C8.5625 4.5 8.75 4.34375 8.75 4.125V2.8125C11.0312 3.15625 12.8438 4.96875 13.1875 7.25H11.875C11.6562 7.25 11.5 7.4375 11.5 7.625V8.375C11.5 8.59375 11.6562 8.75 11.875 8.75H13.1875C12.8438 11.0625 11.0312 12.875 8.75 13.2188ZM9 8C9 7.46875 8.53125 7 8 7C7.4375 7 7 7.46875 7 8C7 8.5625 7.4375 9 8 9C8.53125 9 9 8.5625 9 8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosshairs);
export default __webpack_public_path__ + "static/media/crosshairs.5f645c5e.svg";
export { ForwardRef as ReactComponent };